<template>
  <div class="carouselWeeks" :class="{ '--is-return': !this.isOneWay }">
    <div
      :class="{ '--no-previous': !isValideDate(getPreviousWeekDay) }"
      @click="onDateChanged(getPreviousWeekDay)"
      class="carouselWeeks__button"
    >
      <button class="btn btn-sm" type="button" :title="$t('go_to_back_week')">
        <i class="fas fa-chevron-left"></i>
      </button>
    </div>

    <transition name="fade" mode="out-in" :duration="300">
      <div class="carouselWeeks__week" name="carousel_week">
        <div
          v-for="(price, date) in weeks"
          :key="date + '_day'"
          class="carouselWeeks__day"
          @click="onDateChanged(date)"
          :class="{
            '--selected': actualDateSelected === date,
            '--unavailable': !price || !isValideDate(date),
          }"
        >
          <div class="carouselWeeks__date">
            <span class="carouselWeeks__dateDay">
              {{ date | dateFormat('DD', getLang) }}
            </span>
            <span class="carouselWeeks__dateMonth">
              {{ date | dateFormat('MMM', getLang) }}
            </span>

            <!-- <span class="carouselWeeks__dateSoldOut" v-if="!dateIsBeforeToday(date)">
              {{ $t('sold_out') }}
            </span> -->

            <span class="carouselWeeks__dateDayName">
              {{ date | dateFormat('dddd', getLang) }}
            </span>
          </div>
          <div
            class="carouselWeeks__dayPrice"
            v-if="carouselConfigs.displayFares"
          >
            <p
              v-if="!price || !isIntoConfiguratedDates(date)"
              class="unavailable"
            >
              {{ $t('unavailable') }}
            </p>
            <p class="carouselWeeks__priceValue">
              {{ price | priceFormat }}
            </p>
            <!-- <p class="carouselWeeks__priceCurrency">
              {{ currency }}
            </p> -->
          </div>
        </div>
      </div>
    </transition>

    <div
      :class="{ '--no-next': !isValideDate(getNextWeekDay) }"
      @click="onDateChanged(getNextWeekDay)"
      class="carouselWeeks__button"
    >
      <button class="btn btn-sm" type="button" :title="$t('go_to_next_week')">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'kiu-carousel',
  props: {
    weeks: {
      type: Object,
      required: true,
    },
    isOneWay: {
      type: Boolean,
      required: true,
    },
    carouselConfigs: {
      type: Object,
      required: true,
    },
    actualTripSegment: null,
    isFirstSegment: null,
    initialDates: {},
  },
  data: function () {
    return {
      dates: null
    }
  },
  filters: {
    dateFormat: function (date, typeFormat, lang) {
      return moment(date).locale(lang).format(typeFormat)
    },
    priceFormat: function (price) {
      return price?.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
  },
  beforeMount: function () {
    this.dates = this.initialDates
  },
  computed: {
    getLang: function () {
      return this.$store.getters.getLanguage
    },
    actualDateSelected: function () {
      return Object.keys(this.weeks)[3]
    },
    getPreviousWeekDay() {
      return moment(this.actualDateSelected, 'YYYY-MM-DD')
        .subtract(7, 'd')
        .format('YYYY-MM-DD')
    },
    getNextWeekDay() {
      return moment(this.actualDateSelected, 'YYYY-MM-DD')
        .add(7, 'd')
        .format('YYYY-MM-DD')
    },
    isRoundTrip: function () {
      return !this.isOneWay
    },
  },
  methods: {
    isIntoConfiguratedDates(date) {
      const segment = this.isOneWay ? 'ow' : 'rt'
      const calendarDates = this.carouselConfigs.calendarDates
      return calendarDates[segment] && calendarDates[segment].includes(date)
    },
    onDateChanged(dateSelected) {
      let throwReturnSelectedEvent = false
      let payload = {
        departure_date: null,
        return_date: null,
      }
      if (this.isRoundTrip) {
        const returnDate = moment(this.dates?.arrival, 'DD/MM/YYYY').format(
          'YYYY-MM-DD'
        )
        const departureDate = moment(this.dates?.departure, 'DD/MM/YYYY').format(
          'YYYY-MM-DD'
        )
        if (this.isFirstSegment) {
          payload.departure_date = dateSelected
          this.dates.departure = moment(dateSelected).format('DD/MM/YYYY')
          payload.return_date = returnDate
        } else {
          payload.departure_date = departureDate
          payload.return_date = dateSelected
          this.dates.arrival = moment(dateSelected).format('DD/MM/YYYY')
          // throwReturnSelectedEvent = true
        }
      } else if (this.isFirstSegment) {
        payload.departure_date = dateSelected
        this.dates.departure = moment(dateSelected).format('DD/MM/YYYY')
      } else {
        payload.return_date = dateSelected
        this.dates.arrival = moment(dateSelected).format('DD/MM/YYYY')
      }
      this.$emit('onDateChanged', payload, throwReturnSelectedEvent)
    },
    dateIsBeforeToday(day) {
      return (
        moment(moment.now()).isBefore(day) ||
        moment(day, 'YYYY-MM-DD').format('DD') === moment().format('DD')
      )
    },
    isIntoRange: function (date) {
      if (this.isRoundTrip) {
        const dateToValidate = moment(date, 'YYYY-MM-DD')
        const arrival = moment(this.dates?.arrival, 'DD/MM/YYYY')
        const departure = moment(this.dates?.departure, 'DD/MM/YYYY')
        if (this.isFirstSegment) {
          return dateToValidate.isBefore(arrival)
        } else {
          return dateToValidate.isAfter(departure)
        }
      }
      return true
    },
    isValideDate: function (date) {
      const isIntoRange = this.isIntoRange(date)
      const isIntoConfiguratedDates = this.isIntoConfiguratedDates(date)
      const dateIsBeforeToday = this.dateIsBeforeToday(date)
      return isIntoRange && isIntoConfiguratedDates && dateIsBeforeToday
    },
  },
}
</script>

<style lang="sass">
$background: var(--color-overlay-05)
$grey-nuance-lighter: var(--color-overlay-l-05)
$grey-nuance-darker: var(--color-overlay-05)
$fade-grey: var(--color-overlay-l-05)

.carouselWeeks
  width: 100%
  margin: 0
  display: flex
  i
    color: var(--color-onBackground)
    opacity: 0.5
  p
    margin-bottom: 0
  &__week
    width: 100%
    display: flex
    align-items: center
    justify-content: space-between
    overflow-x: auto
    &.placeholder
      background-color: var(--color-overlay-05)
  &__day
    flex: 1
    margin: 0
    color: var(--color-onBackground)
    background-color: transparent
    width: 100%
    transition: background-color .2s ease
    will-change: background-color
    cursor: pointer
    &:hover
      background-color: var(--color-overlay-l-40)
      .carouselWeeks__date
        box-shadow: 0 2px 0 0px var(--color-overlay-30)
    &.--unavailable
      opacity: .4
      pointer-events: none
      cursor: initial
      .carouselWeeks__date
        border-bottom: 1px dotted var(--color-overlay-30)
    &.--selected
      cursor: initial
      opacity: 1
      .carouselWeeks__date
        box-shadow: 0 2px 0 0px var(--color-primary)
        border-bottom: 1px solid var(--color-primary)
  &__date
    font-size: var(--font-size-sm)
    display: flex
    padding: 4px .5rem
    align-items: baseline
    flex-wrap: wrap
    justify-content: center
    transition: box-shadow .2s ease
    border-bottom: 1px solid var(--color-overlay-30)
  &__dateDay
    font-size: var(--font-size-lg)
    font-weight: 500
    line-height: 1
  &__dateMonth
    font-weight: bold
    margin-left: 3px
    text-transform: uppercase
    font-size: var(--font-size-xs)
  &__dateDayName
    width: 100%
    font-size: var(--font-size-xs)
    text-align: center
  &__dateSoldOut
    width: 100%
    text-align: center
    font-size: var(--font-size-xs)
  &__dayDate
    display: flex
    flex-direction: column
    align-items: center
    font-size: var(--font-size-sm)
    background-color: var(--color-overlay-05)
    padding: 0 .5rem
    border-bottom: 1px solid var(--color-overlay-10)
    span
      font-weight: bold
      font-size: var(--font-size-md)
  &__dayPrice
    font-size: var(--font-size-xs)
    display: flex
    justify-content: center
    align-items: baseline
    padding: .5rem .25rem
    transition: .2s
  &__priceValue
    font-size: var(--font-size-sm)
    margin-right: 4px
    font-weight: bold
  &__button
    .btn
      width: 1.5rem
      height: 100%
      border: 0
    &.--no-next, &.--no-previous
      opacity: .4
      pointer-events: none
      cursor: initial
  @media (min-width: 1200px)
    &__dayDate
      flex-direction: row
      align-items: center
.carouselWeeks__week
  cursor: not-allowed
.carouselWeeks__day.--disabled
  pointer-events: none
.unavailable
  opacity: 0.4
  padding: 2px
.btn-sm,
.btn-group-sm > .btn
  padding: 0 0 !important
.placeholder
  height: 84px
  overflow: hidden
.loads
  display: flex
  width: 100%
  height: 100%
  height: 84px
  animation-duration: 2s
  animation-fill-mode: forwards
  animation-iteration-count: infinite
  animation-name: placeload
  animation-timing-function: linear
  background: $background
  background: $grey-nuance-lighter
  -webkit-background-size: 800px 104px
  background-size: 1200px 104px
  position: relative

@-webkit-keyframes placeload
  0%
    background-position: -468px 0

  100%
    background-position: 468px 0

@keyframes placeload
  0%
    background-position: -468px 0

  100%
    background-position: 468px 0

.fade-enter-active,
.fade-leave-active
  transition: opacity 0.5s
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  opacity: 0
/* july no me regañes */
.float-right
  float: right
.to-fix-button-only
  position: absolute
</style>
